module.exports = __webpack_public_path__ + "static/media/1-6-2.6a6b7538.png";